import axios from "@/assets/helpers/api";

export default {
  state: {
    selectedPlan: {},
    promo_code: {},
    uuid: false,
    is_5g: false,
    plansList: {},
    target: "",
    selectedCityNeighborhoods: [],
    selectedNeighborhoodStreets: [],
    cepError: false,
  },

  getters: {
    getSelectedPlan: (state) => state.selectedPlan,

    getSelectedCity: (state) => state.selectedPlan.city,

    getSelectedCityNeighborhoods: (state) => state.selectedCityNeighborhoods,

    getSelectedNeighborhoodStreets: (state) =>
      state.selectedNeighborhoodStreets,

    getPlansList: (state) => state.plansList,

    getTarget: (state) => state.target,

    getCepError: (state) => state.cepError,

    getDiscount: (state) => state.promo_code,

    getIs5g: (state) => state.is_5g,
  },

  actions: {
    fetchSession: async (_, sessionUuid) => {

      try {
        const { data } = await axios.get(`/session/${sessionUuid}`);
        return data;
      } catch (e) {
        console.log({ error: e });
      }

    },

    fetchSessionOnly: async ({ commit }, sessionUuid) => {
      try {
        const { data } = await axios.get(`/session/${sessionUuid}`)
        commit('setSelectedPlan', data)
        if (data?.pix_enabled !== undefined) {
          commit('internet5g/setPixEnabled', data.pix_enabled, { root: true })
        }
        return data
      } catch (e) {
        console.log({ error: e })
      }
    },

    fetchSelectedPlanBySession: async ({ commit, dispatch }, sessionUuid) => {
      try {
        const { data } = await axios.get(`/session/${sessionUuid}`);

        dispatch("fetchPlansList", data.session.session_uuid);
        commit("setSelectedPlan", data);
        if (data?.pix_enabled !== undefined) {
          commit('internet5g/setPixEnabled', data.pix_enabled, { root: true })
        }
        return data;
      } catch (e) {
        console.log({ error: e });
      }
    },

    fetchSelectedPlan: async (
      { commit, dispatch },
      {
        selectedCity,
        selectedPlan,
        selectedPlanType,
        visitorId,
        target,
        promoCode,
        affiliate
      }
    ) => {
      try {
        const { data: plan } = await axios.post("/session/start", {
          city: selectedCity,
          product: selectedPlan,
          type: selectedPlanType,
          visitor_id: visitorId,
          target: target,
          promo_code: promoCode,
          'tracker': affiliate
        });

        dispatch("fetchPlansList", plan.session.session_uuid);
        dispatch("contractVerification/clearContractStatusFromStorage");
        commit("setSelectedPlan", plan);
        if (plan?.pix_enabled !== undefined) {
          commit('internet5g/setPixEnabled', plan.pix_enabled, { root: true })
        }
      } catch (e) {
        console.log({ error: e });
        // window.location = 'https://weclix.com.br'
      }
    },

    fetchPlansList: async ({ commit }, sessionUuid) => {
      try {
        const { data: plansList } = await axios.get(`/products/${sessionUuid}`);
        commit("setPlansList", plansList);
      } catch (e) {
        console.log({ error: e });
      }
    },

    fetchSelectedCityNeighborhoods: async (
      { commit },
      { sessionUuid, cep }
    ) => {
      commit("setCepError", false);
      try {
        const { data: neighborhoods } = await axios.get(
          `/availability/${sessionUuid}/neighborhoods/cep/${cep}`
        );
        if (!neighborhoods.length) {
          commit("setCepError", true);
        }
        commit("setSelectedCityNeighborhoods", neighborhoods);
      } catch (e) {
        console.log({ error: e });
      }
    },

    fetchSelectedNeighborhoodStreets: async (
      { commit },
      { sessionUuid, neighborhood, cep }
    ) => {
      try {
        const { data: streets } = await axios.get(
          `/availability/${sessionUuid}/neighborhoods/${neighborhood}/streets/cep/${cep}`
        );

        commit("setSelectedNeighborhoodStreets", streets);
      } catch (e) {
        console.log({ error: e });
      }
    },

    checkAvailability: async ({ commit }, { formData, sessionUuid }) => {
      try {
        const { data } = await axios.post(
          `/availability/${sessionUuid}/check`,
          {
            ...formData,
            addressId: +formData.addressId,
          }
        );

        return data;
      } catch (e) {
        console.log(e);
        return e.response.data;
      }
    },

    checkPromoCode: async ({ commit }, { sessionUuid, code }) => {
      const failure = data => ({
        success: false,
        error: data?.errors?.code?.[0] || data?.message?.content ||
          (typeof data?.message === 'string' ? data.message : '') ||
          'Não foi possível aplicar o cupom. Tente novamente.',
      });

      try {
        const { data } = await axios.post(
          `/payment/${sessionUuid}/promo-code`,
          { code: code.trim() }
        );

        if (!data.success) return failure(data);

        commit("setSelectedPlan", data);
        return { success: true };
      } catch (e) {
        return failure(e.response?.data);
      }
    },

    setSelectedPlan: ({ commit }, plan) => {
      commit("setSelectedPlan", plan);
    },

    setTarget: ({ commit }, target) => commit("setTarget", target),

    setCepError: ({ commit }, cepError) => commit("setCepError", cepError),

    updateSelectedPlan: async ({ commit }, { sessionUuid, plan }) => {
      try {
        const { data } = await axios.patch(`/session/${sessionUuid}`, {
          selected_plan_id: plan.id,
          selected_plan_type: plan.combo ? "combo" : "plan",
        });
        commit("setSelectedPlan", data);
      } catch (e) {
        console.log({ error: e });
      }
    },

    updatePlanOrCity: async ({ commit }, { sessionUuid, city, type, product }) => {      

      try {
        const { data } = await axios.patch(`/session/${sessionUuid}`, {
          city,
          product,
          type,
        });

        commit("setSelectedPlan", data);

      } catch (e) {
        console.log({ error: e });
      }
    },

  },

  mutations: {
    
    setSelectedPlan: (state, { product, session, city, promo_code, price, full_price, available_cities }) => {
      state.selectedPlan = { product, city, price:{ price, full_price, },  available_cities };
      localStorage.setItem("session_uuid", session.session_uuid);
      localStorage.setItem("selected_plan_id", session.selected_plan_id);
      state.target = session.target;
      state.uuid = session.session_uuid;
      state.is_5g = Boolean(product?.is_5g ?? false);

      state.promo_code = promo_code || {};
    },

    setCepError: (state, cepError) => {
      state.cepError = cepError;
    },

    usePromoCode: (state, { promo_code }) => {
      state.promo_code = promo_code;
    },

    setSelectedCityNeighborhoods: (state, neighborhoodsList) =>
      (state.selectedCityNeighborhoods = neighborhoodsList),

    setSelectedNeighborhoodStreets: (state, streetsList) =>
      (state.selectedNeighborhoodStreets = streetsList),

    setPlansList: (state, plansList) => (state.plansList = plansList),

    setTarget: (state, target) => (state.target = target),

    setIs5g: (state, value) => (state.is_5g = Boolean(value)),
  },
};
